import React, { PureComponent } from "react";

import Context from "./Context";

// TODO: Refactor this into a functional component
export class GPTProvider extends PureComponent {
  state = { loaded: false, definedSlots: new Set() };

  /**
   * Configure GPT
   * -------------
   */
  configGPT = () => {
    window.googletag.pubads().collapseEmptyDivs();
    window.googletag.pubads().disableInitialLoad();
    //googletag.pubads().enableSingleRequest();
    window.googletag.enableServices();
  };

  /**
   * Initialize the GPT Environment
   * --------------------------------
   * Declare the globals which the GPT script will use when initialized (ex. running commands from the cmd queue).
   */
  initEnv = () => {
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];
  };

  /**
   * Initialize the GPT Script
   * ---------------------------
   * Create a script element (if not present), configure it and append it to the document body.
   * Don't add the script for search page type if not content serp
   */
  initScript = () => {
    const src = "//www.googletagservices.com/tag/js/gpt.js";
    if (!document.querySelector(`script[src="${src}"]`) && (this.props.isContentSerp || !location.href?.includes("&page=search")) ) {
      const script = document.createElement("script");
      script.src = src;
      script.async = 1;

      document.body.appendChild(script);
    }
  };

  /**
   * Initialize the Provider
   * -----------------------
   * Add the configuration and state change to the cmd queue.
   */
  init = () => {
    const { googletag = {} } = window;
    const { cmd } = googletag;

    const { loaded } = this.state;

    if (cmd && !loaded) {
      cmd.push(() => {
        this.configGPT();
        this.setState({ loaded: true });
      });
    }
  };

  componentDidMount() {
    this.initEnv();
    this.initScript();
    this.init();
  }

  render() {
    const { loaded, definedSlots } = this.state;
    const value = { loaded, definedSlots };

    return <Context.Provider {...this.props} value={value} />;
  }
}
